import { DEFAULT_LOCALE, isAppLocale, type AppLocale } from './locales';

export function resolveAppLocale(paramsLocale: string | undefined): AppLocale {
  if (!paramsLocale) return DEFAULT_LOCALE;
  return isAppLocale(paramsLocale) ? paramsLocale : DEFAULT_LOCALE;
}

export function makeLocalePath(locale: AppLocale, path: string): string {
  const clean = path.startsWith('/') ? path : `/${path}`;
  if (clean === '/') return `/${locale}`;
  return `/${locale}${clean}`;
}
